// Genera un SKU automático según el tipo de material y el contador

export function generateSku(type: 'commodity' | 'disposable' | 'cleaning' | 'semi_finished' | 'recipe' | 'equipment', counter: number): string {

    const prefix = {
        commodity: 'PB',
        disposable: 'DE',
        cleaning: 'LI',
        semi_finished: 'SE',
        recipe: 'RE',
        equipment: 'EQ',
    }[type] || 'PB';



    const number = String(counter).padStart(4, '0');

    return `${prefix}-${number}`;
}